export default "__VITE_ASSET__CfhqBpbb__"